export default __webpack_public_path__ + "4c51d1ce1f9a9e10b5f31519ac69cd8d.svg";